import { z } from 'zod';

export const LoginSchema = z.object({
  username: z.string().min(1),
  password: z.string().min(1),
});

export type LoginFormValues = z.infer<typeof LoginSchema>;

export const VerificationSchema = z.object({
  authenticationCode: z
    .string()
    .trim()
    .regex(/^\d{5}$/, 'Please enter valid verification code'),
});

export type VerificationFormValues = z.infer<typeof VerificationSchema>;
